import Base from './base';

class Standard extends Base {
  constructor () {
    super();

    this.getListItemDAL = this.getListItemDAL.bind(this);
    this.addItemDAL = this.addItemDAL.bind(this);
    this.editItemDAL = this.editItemDAL.bind(this);
    this.getItemDAL = this.getItemDAL.bind(this);
    this.deleteItemDAL = this.deleteItemDAL.bind(this);
  }

  getListItemDAL (query) {
    return super.execute(this.Urls.standard.list, this.ApiMethod.get, query);
  }

  addItemDAL (body) {
    return super.execute(this.Urls.standard.create, this.ApiMethod.post, body);
  }

  editItemDAL (id, body) {
    return super.execute(this.Urls.standard.update + '/' + id, this.ApiMethod.put, body);
  }

  getItemDAL (id, options) {
    return super.execute(this.Urls.standard.detail + '/' + id, this.ApiMethod.get, options);
  }

  deleteItemDAL (id) {
    return super.execute(this.Urls.standard.delete + '/' + id, this.ApiMethod.delete, null);
  }
}

export default new Standard();
